/**
 * Eigen apparaten (Gert, collega's, agentbrowsers) dragen een eerste-partij
 * cookie `printen_internal=1`. De funnel telt hun events dan als intern en de
 * prijsroute rekent hun mislukte configuraties niet als echte klant.
 *
 * Zetten: inloggen op /admin, of eenmalig een pagina openen met
 * `?printen_internal=1` (bijvoorbeeld op een telefoon zonder admin-login).
 * Weghalen: `?printen_internal=0`.
 */
export const INTERNAL_DEVICE_COOKIE = 'printen_internal';
const MAX_AGE_SECONDS = 400 * 24 * 60 * 60;

export function cookieHeaderMarksInternalDevice(cookieHeader: string | null | undefined): boolean {
  if (!cookieHeader) return false;
  return cookieHeader.split(';').some((part) => part.trim() === `${INTERNAL_DEVICE_COOKIE}=1`);
}

export function isInternalDevice(): boolean {
  if (typeof document === 'undefined') return false;
  return cookieHeaderMarksInternalDevice(document.cookie);
}

export function setInternalDevice(internal: boolean) {
  if (typeof document === 'undefined') return;
  const secure = typeof location !== 'undefined' && location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = internal
    ? `${INTERNAL_DEVICE_COOKIE}=1; Max-Age=${MAX_AGE_SECONDS}; Path=/; SameSite=Lax${secure}`
    : `${INTERNAL_DEVICE_COOKIE}=; Max-Age=0; Path=/; SameSite=Lax${secure}`;
}

/** Leest `?printen_internal=1|0` uit de huidige URL en zet of wist de cookie. */
export function applyInternalDeviceQueryFlag(search: string) {
  const flag = new URLSearchParams(search).get(INTERNAL_DEVICE_COOKIE);
  if (flag === '1') setInternalDevice(true);
  if (flag === '0') setInternalDevice(false);
}
